import { Candy, CloudLightning, Moon, Smartphone, Beef } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { ENEMIES } from "@/data/site";
import { Reveal, StaggerItem } from "@/components/Reveal";

const ICONS = { candy: Candy, storm: CloudLightning, moon: Moon, phone: Smartphone, burger: Beef };

const Enemies = () => {
  const { t, tr } = useLang();
  return (
    <section className="bg-cream border-b border-ink py-16 md:py-24" data-testid="enemies">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <h2 className="display uppercase text-5xl md:text-7xl leading-[0.85] text-brand max-w-2xl">{t.enemiesTitle}</h2>
          <p className="max-w-sm text-ink/70 font-medium">{t.enemiesSub}</p>
        </Reveal>

        <StaggerItem className="mt-12">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-ink border border-ink">
            {ENEMIES.map((e) => {
              const Icon = ICONS[e.emoji];
              return (
                <div
                  key={e.en}
                  className="group bg-cream hover:bg-blush transition-colors duration-300 p-6 md:p-8 flex flex-col items-center gap-5 text-center"
                >
                  <div
                    className="w-14 h-14 rounded-full flex items-center justify-center border border-ink transition-transform duration-300 group-hover:-rotate-6"
                    style={{ backgroundColor: e.color }}
                  >
                    <Icon className="w-6 h-6 text-ink" strokeWidth={2} />
                  </div>
                  <p className="display uppercase text-xl md:text-2xl leading-none">{tr(e)}</p>
                </div>
              );
            })}
          </div>
        </StaggerItem>
      </div>
    </section>
  );
};

export default Enemies;
